import { render } from "./indust.vue?vue&type=template&id=7c8e8a8a&scoped=true"
import script from "./indust.vue?vue&type=script&lang=js"
export * from "./indust.vue?vue&type=script&lang=js"

import "./indust.vue?vue&type=style&index=0&id=7c8e8a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8e8a8a"]])

export default __exports__